import MobileDrawer from '@c/drawers/MobileDrawer';
import { ProductDocument } from 'models/product';
import EstimateShippingForm from './EstimateShippingForm';

type EstimateShippingResult = {
  cost: number;
  code: string;
  name: string;
  estimated: true;
};

type MobileEstimateShippingProps = {
  product: ProductDocument;
  show: boolean;
  dismiss: (result: EstimateShippingResult | null) => void;
};

export default function MobileEstimateShipping({
  product,
  show,
  dismiss,
}: MobileEstimateShippingProps) {
  return (
    <MobileDrawer
      title="Estimate Shipping"
      show={show}
      dismiss={() => dismiss(null)}
    >
      <div className="flex h-[50rem] w-full flex-col justify-between px-[2rem] py-[3rem]">
        <EstimateShippingForm
          product={product}
          onComplete={dismiss}
          onDismiss={() => dismiss(null)}
        />
      </div>
    </MobileDrawer>
  );
}
